import PaginationOutput from '@/helpers/PaginationOutput';
import salesDummy from '@/constants/salesDummy';
import { salesApi } from '@/api/sales';
import SalesHubBaromoneyDailyVM from '@/view-model/SalesHubBaromoneyDailyVM';
import SalesHubBaromoneyMonthlyVM from '@/view-model/SalesHubBaromoneyMonthlyVM';
import InvoiceDeliveryChargeVM from '@/view-model/InvoiceDeliveryChargeVM';
import InvoiceUseHistoryVM from '@/view-model/InvoiceUseHistoryVM';
import SalesStoreBaromoneyVM from '@/view-model/SalesStoreBaromoneyVM';
import SalesStoreBaromoneyDailyDetailVM from '@/view-model/SalesStoreBaromoneyDailyDetailVM';
const apiMap = {
    store: {},
    hub: {
        daily: (data) => salesApi.getSalesHubBaromoneyDaily(data),
        monthly: (data) => salesApi.getSalesHubBaromoneyMonthly(data),
        dailyDetail: (data) => salesApi.getSalesHubBaromoneyDailyDetail(data),
    },
};
const entityMap = {
    store: {},
    hub: {
        daily: SalesHubBaromoneyDailyVM,
        monthly: SalesHubBaromoneyMonthlyVM,
        // dailyDetail: StatsHubDailyDetailVM,
    },
};
/**
 * 매출 서비스 레이어
 */
export const salesService = {
    /**
     * 매출 조회
     */
    async getHubBaromoney(serviceData) {
        const api = apiMap[serviceData.resourceType][serviceData.dateType];
        const entity = entityMap[serviceData.resourceType][serviceData.dateType];
        let response;
        if (window.Cypress) {
            response = await api(serviceData.createReqBody());
        }
        else {
            response = await Promise.resolve({
                data: {
                    data: {
                        list: salesDummy[serviceData.resourceType][serviceData.dateType],
                        totalCount: 0,
                    },
                },
            });
        }
        return PaginationOutput.adaptorFactory(response, entity);
    },
    /**
     * 허브 바로머니 일별 상세 조회
     */
    async getHubBaromoneyDailyDetail(serviceData) {
        const api = apiMap.hub.dailyDetail;
        const entity = entityMap.hub.dailyDetail;
        let response;
        if (window.Cypress) {
            response = await api(serviceData.createReqBody());
        }
        else {
            response = await Promise.resolve({
                data: {
                    data: {
                        list: salesDummy.hub.dailyDetail,
                        totalCount: 0,
                    },
                },
            });
        }
        return PaginationOutput.adaptorFactory(response, entity);
    },
    /**
     * 배송운임 조회
     */
    async getDeliveryCharge(serviceData) {
        let response;
        if (window.Cypress) {
            response = await salesApi.getDeliveryCharge(serviceData.createReqBody());
        }
        else {
            response = await salesApi.getDeliveryCharge(serviceData.createReqBody());
            // response = await Promise.resolve({
            //   data: {
            //     data: {
            //       list: (salesDummy as any).hub.dailyDetail,
            //       totalCount: 0,
            //     },
            //   },
            // }) as unknown as AxiosResponse<PaginationOutput<InvoiceDeliveryChargeVM>>;
        }
        return PaginationOutput.adaptorFactory(response, InvoiceDeliveryChargeVM);
    },
    /**
     * 사용내역서 조회
     */
    async getUseHistory(serviceData) {
        let response;
        if (window.Cypress) {
            response = await salesApi.getUseHistory(serviceData.createReqBody());
        }
        else {
            response = await salesApi.getUseHistory(serviceData.createReqBody());
            // response = await Promise.resolve({
            //   data: {
            //     data: {
            //       list: (salesDummy as any).hub.dailyDetail,
            //       totalCount: 0,
            //     },
            //   },
            // }) as unknown as AxiosResponse<PaginationOutput<InvoiceUseHistoryVM>>;
        }
        return PaginationOutput.adaptorFactory(response, InvoiceUseHistoryVM);
    },
    /**
     * 상점 바로머니 조회
     */
    async getStoreBaromoney(serviceData) {
        const response = await salesApi.getSalesStoreBaromoney(serviceData.createReqBody());
        return PaginationOutput.adaptorFactory(response, SalesStoreBaromoneyVM);
    },
    /**
     * 상점 바로머니 일별 상세 조회
     */
    async getStoreBaromoneyDailyDetail(serviceData) {
        const response = await salesApi.getSalesStoreBaromoneyDailyDetail(serviceData.createReqBody());
        return PaginationOutput.adaptorFactory(response, SalesStoreBaromoneyDailyDetailVM);
    },
};
